import initialState from '../core/initialState';
import Event from '../core/Event';
import UserOrder from '../../domain/UserOrder';
import UserOrdersGetSucceed from './events/UserOrdersGetSucceed';

export default (state: UserOrder[] = initialState.userOrders, anyEvent: Event): UserOrder[] => {
    switch (anyEvent.type) {
        case UserOrdersGetSucceed.type:
            return (anyEvent as UserOrdersGetSucceed).orders;
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/order/reducer.ts